import { render, staticRenderFns } from "./logistics_certificate.vue?vue&type=template&id=7e7ef549&scoped=true&"
import script from "./logistics_certificate.vue?vue&type=script&lang=js&"
export * from "./logistics_certificate.vue?vue&type=script&lang=js&"
import style0 from "./logistics_certificate.vue?vue&type=style&index=0&id=7e7ef549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7ef549",
  null
  
)

export default component.exports